var JuneCommon = {};

JuneCommon.isOutOfStock = function(product) {
  var count = 0;
  var { variants } = product;

  variants.forEach(element => {
    count += element.inventory_quantity;
  });

  return count == 0;
}

var getCartItemQuantity = product => {
  const cartItem = window.globalVariables.cart.items.find(item => {
    return product.variants.find(variant => variant.id == item.variant_id)
  });
  return cartItem ? cartItem.quantity : 0;
}

var getVariantName = (variants, multipleOptions) => {
  if (variants.length > 1) {
    return 'Various options';
  } else if (multipleOptions) {
    return variants[0].option2;
  }
  return variants[0].title;
}

var getPromotionTag = (product, isOutOfStock) => {
  if (isOutOfStock) {
    return 'Out of stock';
  }
  var tags = product.tags.split(', ').map(tag => tag.toLowerCase());
  if (tags.includes('promo_new')) {
    return 'New';
  } else if (tags.includes('promo_special')) {
    return 'Special';
  } else if (tags.includes('promo_exclusive')) {
    return 'Exclusive';
  } else if (tags.includes('promo_clearance')) {
    return 'Clearance';
  } else if (tags.includes('promo_bundle')) {
    return 'Bundle';
  }
  return '';
}

var enhanceProduct = (product, eagerLoadImg) => {
  const isOutOfStock = JuneCommon.isOutOfStock(product);
  const promotionTag = getPromotionTag(product, isOutOfStock);

  const quantityInCart = getCartItemQuantity(product);
  const { title, variants, images, image } = product;
  const multipleOptions = product.options.length > 1;
  const firstVariant = variants[0];
  const price = firstVariant.price * 1;
  const { id: productId, title: firstVariantName, image_id: imageId, option1 } = firstVariant;
  const isGiftCard = product.handle === 'gift-card';
  const showActionBox = !isGiftCard && variants.length <= 1;

  const enhancedProduct = Object.assign({}, product, {
    productId,
    eagerLoadImg,
    promotionTag,
    quantityInCart,
    isGiftCard,
    isSpark: window.isVipMember,
    cardTitle: multipleOptions ? `${title} - ${option1}` : title,
    variantName: getVariantName(variants, multipleOptions),
    url: `/collections/all/products/${product.handle}?variant=${productId}`,
    grandeImage: JuneCommon.findImageById(product, imageId) || (image && image.src),
    grandeMainImage: JuneCommon.findImageById(product, imageId) || (image && image.src),
    price: JuneCommon.money(price),
    promotionTagClass: promotionTag.toLowerCase().split(' ').join('-'),
    images: images && images.map(img => img.src),
    multiple: images && images.length > 1 && product.body_html.includes("[item-gallery]"),
    removeBtnVisibility: visibilityClazz(showActionBox && quantityInCart > 0),
    actionBoxVisibility: visibilityClazz(showActionBox),
    isOutOfStock,
    product: JSON.stringify(product)
  });

  return enhancedProduct;
}

var visibilityClazz = (condition) => {
  return condition ? 'visible' : 'invisible';
}

JuneCommon.findImageById = function(product, imageId) {
  var imageUrl = '';
  const images = product.images || [];
  images.forEach(function(item){
    if(item.id == imageId) {
      imageUrl = item.src;
      return;
    }
  });
  return imageUrl;
}

JuneCommon.money = function(amount) {
  return `$${Math.round(amount * 100) / 100}`
}

var handleProductActions = (e, productId, added) => {
  e.preventDefault();
  const quantityElement = $(`#product-quantity-${productId}`);
  let quantity = Number(quantityElement.text());
  quantity += added;
  $.post('/cart/update.js', { updates: { [productId]: quantity } }, function (response) {
    if (added > 0) {
      window.CartJS.showNotification(added);
    }
    window.CartJS.updateRenderedCart(false);
  }, "json")
    .error(function() {
      quantityElement.text(quantity - added);
    });
}

var clearOOSPopup = () => {
  $('#oos-popup-msg').removeClass('success error');
}

var handleBISResponse = (error) => {
  var text, clazz;
  if (!error) {
    text = 'Your notification has been registered.';
    clazz = 'success';
  } else {
    text = error;
    clazz = 'error';
  }
  $('#oos-popup-msg > span').text(text);
  $('#oos-popup-msg').addClass(clazz);
  $('#oos-popup-msg > a').on('click', closeOOSPopup);
}

var createBISFormData = (email, variantId, acceptsMarketing) => {
  const { API_KEY, BIS_LIST } = window.ENV.KlaviyoConfigs;
  var formData = new FormData();
  formData.append("a", API_KEY);
  if (acceptsMarketing) {
    formData.append("g", BIS_LIST);
  }
  formData.append("platform", "shopify");
  formData.append("email", email);
  formData.append("variant", variantId);
  formData.append("subscribe_for_newsletter", acceptsMarketing);
  return formData;
}

var trackAcceptsMarketing = (email, acceptsMarketing) => {
  const data = {
    "token" : window.ENV.KlaviyoConfigs.API_KEY,
    "properties" : {
      "$email" : email,
      "Accepts Marketing" : acceptsMarketing
    }
  }

  const encodedData = window.btoa(JSON.stringify(data));
  $.get(`https://a.klaviyo.com/api/identify?data=${encodedData}`, function(result) {
    console.log(result);
  });
}

var handleOOSPopupSubmit = (product) => {
  $('#oos-popup-submit-btn').on('click', () => {
    try {
      clearOOSPopup();
      var email = $('#oos-popup-email').val().trim();
      var { id, productId: variantId } = product;
      var acceptsMarketing = $('#oos-popup-cb:checkbox:checked').length > 0;

      $.ajax({
        url: 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
        type: 'POST',
        data: createBISFormData(email, variantId, acceptsMarketing),
        processData: false,
        contentType: false
      }).done(res => {
        handleBISResponse();
        trackAcceptsMarketing(email, acceptsMarketing);
      }).fail(res => {
        const errors = res.responseJSON.message.split('*');
        handleBISResponse(errors[errors.length - 1]);
      })
    } catch (e) {
      console.log(e);
    }
  })
}

var fillUpProductInfo = (product) => {
  const { cardTitle, variantName, vendor } = product
  $('#oos-popup-brand').text(`${vendor}`);
  $('#oos-popup-name').text(`${cardTitle} - ${variantName}`);
}

var closeOOSPopup = () => {
  $('#oos-popup').removeClass('oos-popup-active');
  clearOOSPopup();
}

var openOOSPopup = () => {
  clearOOSPopup();
  const popup = $('#oos-popup');
  popup.addClass('oos-popup-active');
  popup.on('click', e => {
    e.stopPropagation();
  })
  $('#oos-popup-close').on('click', closeOOSPopup);
  $('html').removeClass('cart-active');
}

var handleOOSPopup = (product, e) => {
  e.preventDefault();
  e.stopPropagation();
  openOOSPopup();
  fillUpProductInfo(product);
  handleOOSPopupSubmit(product);
}

JuneCommon.observeProductActions = (product) => {
  const { productId } = product
  $(`#product-${productId}`).on("click", '.add-to-cart', (e) => {
    handleProductActions(e, productId, 1);
  });
  $(`#product-${productId}`).on("click", '.remove-from-cart', (e) => {
    handleProductActions(e, productId, -1);
  });
  $(`#product-${productId}`).on("click", '.notify-me', (e) => {
    handleOOSPopup(product, e);
  });
}

JuneCommon.enhanceAndRender = (container, template, clazz, product, eagerLoadImg, index) => {
  var enhancedProduct = this.enhanceProduct(product, eagerLoadImg);
  var rendered = Mustache.render(template, enhancedProduct);
  var id = index || enhancedProduct.productId
  container.append(`<div class="${clazz}" id="product-${id}"> ${rendered} </div>`);
  JuneCommon.observeProductActions(enhancedProduct);
}

var handleOOSPopupInProductDetail = () => {
  $("#notify-me-product-detail").on("click", e => {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    const product = window.globalVariables.product;
    const { id, title: cardTitle, variants, vendor } = product;
    const variant = product.variants.find(v => v.id == variantId) || product.variants[0];
    const { option1, option2 } = variant;
    const enhancedProduct = {
      id,
      vendor,
      cardTitle,
      variantName: option2 ? `${option1} - ${option2}` : option1,
      productId: variantId
    }
    handleOOSPopup(enhancedProduct, e);
  });
}

JuneCommon.updateProductQuantityFromCart = function () {
  const Cart = window.globalVariables.cart;
  Cart.items.forEach(cartItem => {
    $(`#product-action-box-${cartItem.id} .product-action-text-bold`).text(cartItem.quantity);
    $(`#product-action-box-${cartItem.id} .product-action-text-wrapper`).removeClass('invisible');
    $(`#product-action-box-${cartItem.id} .remove-from-cart`).removeClass('invisible');
  });
}

JuneCommon.transformProduct = (product, variant) => {
  return Object.assign({},
    product,
    {
      tags: product.tags.join(', '),
      body_html: product.content,
      images: [],
      image: variant.featured_image,
      variants: [
        Object.assign({}, variant, { price: product.variants[0].price / 100 })
      ]
    }
  )
}

$(function () {
  handleOOSPopupInProductDetail();
  $(window).on('click', closeOOSPopup);
})
